/**
 * Dumb renderer for selection actions (zoom/clear).
 */

import React from "react";
import Button from "@mui/material/Button";

export default function SelectionActions({
  showZoom,
  zoomLabel,
  onZoom,
  showClear,
  clearLabel,
  onClear,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        justifyContent: "space-between",
        alignItems: "stretch",
      }}
    >
      {showZoom && (
        <Button
          data-cy="zoom-to-selected-button"
          color="primary"
          variant="outlined"
          size="small"
          onClick={onZoom}
          sx={{ padding: "4px", flex: "1 1 160px", minWidth: 0 }}
        >
          {zoomLabel}
        </Button>
      )}

      {showClear && (
        <Button
          data-cy="clear-selection-button"
          color="secondary"
          variant="outlined"
          size="small"
          onClick={onClear}
          sx={{ padding: "4px", flex: "1 1 160px", minWidth: 0 }}
        >
          {clearLabel}
        </Button>
      )}
    </div>
  );
}
